export const environment = {
    apiRoot: 'https://adp.n-denton.com/adp_api',
    //apiRoot: 'http://127.0.0.1:8082',
    jwtToken: 'JWT_TOKEN',
};
